import React from "react";
import "./gameFeatures.scss";
import gameloopImg from "../../assets/imgs/gameloop.png";
import GameCard from "./GameFeatureCard";
import LazyLoad from "react-lazyload";

import { GameFeatureData } from "../../assets/Data/GameFeatureData";
const GameFeatures = () => {
    return (
        <section className="container features">
            <div className="grid wide">
                <div className="gameloop">
                    <h3 className="textBox__title">
                        You Run and You get Rewards
                    </h3>
                    <div className="gameloop-img">
                        <img src={gameloopImg} alt="gameloop" />
                    </div>
                </div>

                <div className="game-features">
                    <h3 className="textBox__title">Game Features</h3>

                    <div className="row">
                        {GameFeatureData.map((item) => (
                            <GameCard key={item.id} item={item} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GameFeatures;
